import { SCROLL_ELEMENTS, TRANSPARENCY_TOOLBAR_HEIGHT } from '@/content/values/ed-presentation-mode.values';

class EdPresentationModeScroll {
    private initialVerticalOffset = TRANSPARENCY_TOOLBAR_HEIGHT; //
    private scrollReferences : any = {
        pdfViewer: [],
        responseType: [],
        imagesViewer: [],
        textViewer: []
    }

    public createEventListeners(isBoardHomework : boolean = false) : Promise<void> {
        return new Promise((resolve) => {
            this.scrollReferences.pdfViewer = document.getElementsByClassName(SCROLL_ELEMENTS.pdf.className);
            this.scrollReferences.responseType = document.getElementsByClassName(SCROLL_ELEMENTS.responseType.className);
            this.scrollReferences.imagesViewer = document.getElementsByClassName(SCROLL_ELEMENTS.images.className);
            this.scrollReferences.textViewer = document.getElementsByClassName(SCROLL_ELEMENTS.text.className);
            this.scrollReferences.pdfViewer.forEach((documentElement: HTMLElement) => this.hideOverflow(documentElement, isBoardHomework));
            this.scrollReferences.responseType.forEach((documentElement: HTMLElement) => this.hideOverflow(documentElement, isBoardHomework));
            this.scrollReferences.imagesViewer.forEach((documentElement: HTMLElement) => this.hideOverflow(documentElement, isBoardHomework));
            this.scrollReferences.textViewer.forEach((documentElement: HTMLElement) => this.hideOverflow(documentElement, isBoardHomework));
            resolve();
        });
    }

    public moveScroll(data : any, isLoading: boolean) : Promise<boolean> {
        return new Promise((resolve) => {
            if (isLoading) {
                return resolve(true);
            }

            for (let key in data) {
                if(!(data[key] && this.scrollReferences[data[key].type] && this.scrollReferences[data[key].type][data[key].elementIndex])){
                    continue;
                }
                const scrollReferenceElement = this.scrollReferences[data[key].type][data[key].elementIndex];

                let scrollHeight = scrollReferenceElement.scrollHeight - this.initialVerticalOffset;
                let scrollTop = data[key].scrollTop;
                scrollTop = scrollHeight * scrollTop;

                scrollReferenceElement.scrollTo(0, scrollTop);
            }
            resolve(true);
        });
    }

    public hideTypeResponseScroll() : void {
        this.scrollReferences.responseType = document.getElementsByClassName(SCROLL_ELEMENTS.responseType.className);
        this.scrollReferences.responseType.forEach(this.hideOverflow);
    }

    public obtainScrolltop(type: string, elementIndex: number) : number {
        if(!(this.scrollReferences[type] && this.scrollReferences[type][elementIndex])){
            return 0;
        }        
        return this.scrollReferences[type][elementIndex].scrollTop;
    }

    private hideOverflow(documentElement : HTMLElement, isBoardHomework : boolean) : void {
        if(isBoardHomework){
            documentElement.style.removeProperty('overflow');
        }else {
            documentElement.style.overflow = 'hidden';
        }
    }
}

export default new EdPresentationModeScroll();
